import React, { Component } from 'react';
import './assets/App.css';
import {Route} from 'react-router-dom';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { ApolloProvider } from 'react-apollo';
import logo from './assets/logo.svg';
import { withRouter } from "react-router";
import FormSwitch from './FormSwitch';
import { setContext } from 'apollo-link-context';

const BUGGY_API_URL = "https://buggy-174216.appspot.com/webql/";
// const BUGGY_API_URL = "http://127.0.0.1:8000/webql/";
// const BUGGY_API_URL = "https://a9ce1370.ngrok.io/webql/";
const TOKEN = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6Ik5peWkiLCJleHAiOjE1OTUyODAzMDYsIm9yaWdJYXQiOjE1OTUyODAwMDZ9.NUkuV9irTpJrBuCDsN-_I--DX6wuI0tz6b5f4sDZ5Z8"
// const TOKEN = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6ImFobWVkLnNhcmZyYXoiLCJleHAiOjE2MjYyNTM1NzcsIm9yaWdJYXQiOjE2MjYyNTMyNzd9.4nQZouqMk7upIzvaPNjXC4uOlrv6C5P2y6Aj4k4bWd0"
const httpLink = createHttpLink({
  uri: BUGGY_API_URL,
});
const authLink = setContext((_, { headers }) => {
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: `jwt ${TOKEN}`,
    }
  }
});
const client = new ApolloClient({
  cache: new InMemoryCache(),
  // link: httpLink
  link: authLink.concat(httpLink),
});


class App extends Component {
  render() {
    return (
  
        <ApolloProvider client={client}>
          <div className="container">
            <header className="App-header">
              <img src={logo} className="buggyLogo" alt="logo" />
            </header>
            <Route path="/:id/:type" component={FormSwitch}/>
          </div>
        </ApolloProvider>
    );
  }
}

export default withRouter(App);
